export const useVideoStore = defineStore({
  id: 'videoStore',
  state: () => ({
    volume: 1,
    muted: false,
  }),
})
